import { Box } from "@mui/material";
import type { SxProps, Theme } from "@mui/material";
import type { ReactNode } from "react";
import { brainTokens } from "../design/brainTheme";
import { MonoLabel } from "./MonoLabel";
import { Sparkle } from "./icons";

const c = brainTokens.color;

/**
 * The teal-tint AI block. EVERY AI-derived surface uses this: nightly summary,
 * demand signals, etc. Sparkle avatar + mono `AGENT · <context>` label +
 * optional freshness stamp + children.
 */
export function AgentPanel({
  context,
  stamp,
  children,
  sx,
}: {
  context: ReactNode;
  stamp?: ReactNode;
  children?: ReactNode;
  sx?: SxProps<Theme>;
}) {
  return (
    <Box
      sx={{
        background: c.tealTint2,
        border: `1px solid ${c.tealTintBorder}`,
        borderRadius: `${brainTokens.radius.card}px`,
        p: "15px 17px",
        display: "flex",
        gap: "12px",
        alignItems: "flex-start",
        ...sx,
      }}
    >
      <Box
        sx={{
          width: 26,
          height: 26,
          borderRadius: "7px",
          background: c.tealAvatarBg,
          color: c.teal,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flex: "none",
        }}
      >
        <Sparkle size={14} />
      </Box>
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: "9px", mb: "5px", flexWrap: "wrap" }}>
          <MonoLabel color={c.teal}>AGENT · {context}</MonoLabel>
          {stamp != null && stamp !== "" && (
            <Box component="span" sx={{ fontSize: 11, color: c.tealStamp }}>
              {stamp}
            </Box>
          )}
        </Box>
        <Box sx={{ fontSize: 14, color: c.tealBodyInk, lineHeight: 1.6 }}>{children}</Box>
      </Box>
    </Box>
  );
}
